import random from "random-string-generator";
import { encode as base64encode } from "base64-arraybuffer";

import { getRandomInt } from "./mathUtils.ts";

export interface PkceParams {
  code_verifier: string;
  code_challenge: string;
  code_challenge_method: "S256";
  state: string;
}

async function generateCodeChallenge(codeVerifier: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  const base64Digest = base64encode(digest);

  return base64Digest.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

export async function generatePkceParams(): Promise<PkceParams> {
  const type =
    "scoped:ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

  const code_verifier = random(getRandomInt(43, 128), type);
  const state = random(getRandomInt(32, 32), type);

  const code_challenge = await generateCodeChallenge(code_verifier);

  return {
    code_verifier,
    code_challenge,
    code_challenge_method: "S256",
    state,
  };
}
